// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment-timezone';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import EventsMobile from './EventsMobile';

export class Events extends React.PureComponent {
  onEventClick = ({ currentTarget }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onEventClick } = this.props;
    onEventClick(currentTarget.getAttribute('to'));
  };

  getEventTime = (event, tz) => {
    return `${moment(event.startTime).tz(tz).format('hh:mm A z')} to ${moment(
      event.endTime
    )
      .tz(tz)
      .format('hh:mm A z')}`;
  };

  renderOtherEvent = (event, tz) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { overboard } = this.props;
    if (event.timeTBD) {
      return this.renderEvent(
        'Time TBD',
        event.eventName,
        event.eventTitle,
        event
      );
    }
    if (overboard) {
      return this.renderEvent(
        this.getEventTime(event, tz),
        event.eventName,
        event.eventTitle,
        event
      );
    }
    return this.renderEvent(
      this.getEventTime(event, tz),
      event.eventName,
      event.eventTitle,
      event
    );
  };

  renderEvent = (time, place, eventTitle, event) => (
    <tr
      key={event.eventId}
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      to={event.eventId}
      className='listrow'
      onClick={this.onEventClick}
    >
      <td style={{ width: '20%' }}>{time}</td>
      <td>{eventTitle}</td>
      <td>{place}</td>
    </tr>
  );

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { events, tz } = this.props;

    if (isMobileResolution()) {
      return (
        <EventsMobile
          events={events}
          tz={tz}
          getEventTime={this.getEventTime}
          onEventClick={this.onEventClick}
        />
      );
    }

    return (
      <Fragment>
        <Table>
          <thead>
            <tr>
              <th>Time</th>
              <th>Event Title</th>
              <th>Venue Name</th>
            </tr>
          </thead>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <tbody>{events.map(event => this.renderOtherEvent(event, tz))}</tbody>
        </Table>
      </Fragment>
    );
  }
}
